import { PasswordFormValues, PasswordFormError } from 'types/state';

export const validatePasswordFormValues = (
  values: PasswordFormValues
): PasswordFormError | undefined => {
  if (values.password !== values.passwordConfirm) {
    return 'PASSWORDS_DID_NOT_MATCH';
  }
};
